import { render, staticRenderFns } from "./ADpageWithWxForm.vue?vue&type=template&id=ae5c091e&scoped=true&"
import script from "./ADpageWithWxForm.vue?vue&type=script&lang=tsx&"
export * from "./ADpageWithWxForm.vue?vue&type=script&lang=tsx&"
import style0 from "./ADpageWithWxForm.vue?vue&type=style&index=0&id=ae5c091e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5c091e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae5c091e')) {
      api.createRecord('ae5c091e', component.options)
    } else {
      api.reload('ae5c091e', component.options)
    }
    module.hot.accept("./ADpageWithWxForm.vue?vue&type=template&id=ae5c091e&scoped=true&", function () {
      api.rerender('ae5c091e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingADpages/ADpageWithWxForm.vue"
export default component.exports